import { useIsMobileOrTablet } from '@/hooks/use-media-query';
import { useSSRContext } from '@/ssr-context';

export function Desktop({ children }: React.PropsWithChildren<{}>) {
  const ssr = useSSRContext();
  const isSmallScreen = useIsMobileOrTablet();
  if ((ssr.isSSR && !ssr.isUAMobile) || (!ssr.isSSR && !isSmallScreen))
    // eslint-disable-next-line
    return <>{children}</>;
  // eslint-disable-next-line
  return <></>;
}

export function Mobile({ children }: React.PropsWithChildren<{}>) {
  const ssr = useSSRContext();
  const isSmallScreen = useIsMobileOrTablet();
  if ((ssr.isSSR && ssr.isUAMobile) || (!ssr.isSSR && isSmallScreen))
    // eslint-disable-next-line
    return <>{children}</>;
  // eslint-disable-next-line
  return <></>;
}
